/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Commands_LabelInputs */

const en_cad_features_commands_label = /** @type {(inputs: Cad_Features_Commands_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commands`)
};

/**
* | output |
* | --- |
* | "Commands" |
*
* @param {Cad_Features_Commands_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_commands_label = /** @type {((inputs?: Cad_Features_Commands_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Commands_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_commands_label(inputs)
});
export { cad_features_commands_label as "cad.features.commands_label" }